import React, { useState, useEffect, useRef } from 'react';
import { get, post, put } from '../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon, ViewIcon } from './icons';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from './Pagination';
import useDebounce from './useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import Breadcrumb from '../components/Breadcrumb';

const AssetCategory = () => {
  const formFields = { assetName: '', assetType: '', assetLife: '', rodCompanyAct: '', rodItAct: '' };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [assetCategoryForm, setAssetCategoryForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  // const [idToDeleted, setIdToDeleted] = useState("");
  // const [deleteModel, setDeleteModel] = useState(false);
  const [assetCategoryList, setAssetCategoryList] = useState([]);
  const [query, setQuery] = useState('');
  const clickToDownload = useRef(null);

  const handleShow = () => {
    setShowConfirmModel(true);
    setAssetCategoryForm(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleViewAndEdit = (e, id) => {
    e.preventDefault();
    try {
      get('/asset-categories/?id=' + id).then((response) => {
        if (response.data.rows.length) {
          const Data = response.data.rows[0];
          setAssetCategoryForm(Data);
          setShowConfirmModel(true);
        } else {
          toast.error('No asset found with this name');
        }
      });
    } catch (error) {
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setAssetCategoryForm({ ...assetCategoryForm, [name]: value });
  };

  // const handleRemove = (event, id) => {
  //   event.preventDefault();
  //   try {
  //     destroy('/asset-categories/' + id).then(response => {
  //       toast.success("Asset Deleted successfully");
  //       setDeleteModel(false);
  //       getAssetsCategory();
  //     })
  //   }
  //   catch (err) {
  //     toast.error(err.message, { autoClose: 2000 });
  //   }
  // }

  // const handleConfirmDeleteModal = (e, id) => {
  //   e.preventDefault();
  //   setDeleteModel(true);
  //   setIdToDeleted(id);
  // }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in assetCategoryForm) {
      // try {
      //   await put(assetCategoryForm, '/asset-categories/' + assetCategoryForm.id)
      //   toast.success("Asset updated successfully");
      //   setShowConfirmModel(false);
      //   getAssetsCategory();
      // } catch (err) {
      //   toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 3000 });
      // }
    } else {
      try {
        await post(assetCategoryForm, '/asset-categories/');
        toast.success('Asset created successfully');
        setShowConfirmModel(false);
        getAssetsCategory();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
      }
    }
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getAssetsCategory();
      }
    },
    [query],
    DEBOUNCE_DELAY
  );

  function getAssetsCategory() {
    try {
      get(`/asset-categories/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}`).then((response) => {
        setAssetCategoryList(response.data.rows);
        setTotalRecords(response.data.count);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function excelReport() {
    try {
      get(`/asset-categories/?conditionType=download`).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useEffect(() => {
    getAssetsCategory();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Fixed Asset' },
          { link: '#', title: 'Master' },
          { link: '#', title: 'Asset Category' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Asset Categories | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by category name"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <GrDocumentExcel title="Download assets categories" className="react-icons green" onClick={excelReport} />
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
            <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
              Add Category
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Category Name</th>
                    <th>Category Type</th>
                    <th>Life</th>
                    <th>ROD Company ACT</th>
                    <th>ROD IT ACT</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {assetCategoryList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{item?.name}</td>
                        <td style={{ textTransform: 'upperCase' }}>{item?.type}</td>
                        <td>{item?.life + ' yrs'}</td>
                        <td>{item?.rod_company_act}</td>
                        <td>{item?.rod_it_act}</td>
                        <td className="actions">
                          {/* <span onClick={(e) => handleViewAndEdit(e, item?.id)} className="edit-icon"><EditIcon /></span> */}
                          <span onClick={(e) => handleViewAndEdit(e, item?.id)} className="view-icon">
                            <ViewIcon style={{ cursor: 'pointer', color: 'purple' }} />
                          </span>
                          {/* <Link onClick={(e) => handleConfirmDeleteModal(e, item?.id)} className="delete" to="/"><DeleteIcon /></Link> */}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{'id' in assetCategoryForm ? `${assetCategoryForm?.name} Asset Category Details` : 'Add Category '}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <Row>
              <Col xs={12}>
                <FloatingLabel controlId="floatingInput" label="Category Name" className="mb-3">
                  <Form.Control
                    disabled={'id' in assetCategoryForm}
                    className="input"
                    name="name"
                    value={assetCategoryForm.name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Category Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={12}>
                <FloatingLabel controlId="floatingInput" label="Asset Type" className="mb-3">
                  <Form.Select
                    disabled={'id' in assetCategoryForm}
                    className="input"
                    value={assetCategoryForm.type}
                    name="type"
                    onChange={handleChange}
                    placeholder="Asset Type"
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="tan">TAN</option>
                    <option value="int">INT</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={12} lg={4}>
                <FloatingLabel controlId="floatingInput" label="Asset Life" className="mb-3">
                  <Form.Control
                    disabled={'id' in assetCategoryForm}
                    className="input"
                    name="life"
                    value={assetCategoryForm.life}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && value >= 0) {
                        handleChange(e);
                      }
                    }}
                    type="text"
                    placeholder="Asset Life"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={12} lg={4}>
                <FloatingLabel controlId="floatingInput" label="ROD Company ACT" className="mb-3">
                  <Form.Control
                    disabled={'id' in assetCategoryForm}
                    className="input"
                    name="rod_company_act"
                    value={assetCategoryForm.rod_company_act}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && value >= 0) {
                        handleChange(e);
                      }
                    }}
                    type="text"
                    placeholder="ROD Company ACT"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={12} lg={4}>
                <FloatingLabel controlId="floatingInput" label="ROD IT ACT" className="mb-3">
                  <Form.Control
                    disabled={'id' in assetCategoryForm}
                    className="input"
                    name="rod_it_act"
                    value={assetCategoryForm.rod_it_act}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && value >= 0) {
                        handleChange(e);
                      }
                    }}
                    type="text"
                    placeholder="ROD IT ACT"
                    required
                  />
                </FloatingLabel>
              </Col>
              {!assetCategoryForm.id && (
                <Col xs={12}>
                  <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3 justify-content-center">
                    Add
                  </Button>
                </Col>
              )}
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      {/* <Modal
        size="sm"
        show={deleteModel}
        backdrop="static"
        keyboard={false}
        className="request-modal"
      >
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Assets</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="alert icon" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={() => setDeleteModel(false)} className="btn app-btn-default btn-sm">Cancel</button>
            <button onClick={(event) => handleRemove(event, idToDeleted)} className="btn app-btn-danger btn-sm">Delete</button>
          </div>
        </Modal.Footer>
      </Modal> */}
    </React.Fragment>
  );
};

export default AssetCategory;
